import { useState, useEffect } from "react";
import { FaRegUser, FaEyeSlash } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import { MdClose } from "react-icons/md";

const SettingView = ({
  settingOpen,
  setSettingOpen,
  selectedFolder,
  setFiles,
  files,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [users, setUsers] = useState([]);
  
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [passwordset, SetPasswordSet] = useState("Yes");

   const [privacy, setPrivacy] = useState("public");
    const [passwordSet, setPasswordSet] = useState(""); 
    const [password, setPassword] = useState("");
  const allUsers = ["Kumar", "Vijay", "Lokesh", "Parthiban"];

  useEffect(() => {
    if (selectedFolder) {
      setPrivacy(selectedFolder.privacy || "public");
      setPassword(selectedFolder.password || "");
      setUsers(selectedFolder.users || []);
    }
  }, [selectedFolder]);

  const handleSaveChanges = () => {
    const updatedFiles = files.map((file) =>
      file._id === selectedFolder._id
        ? {
            ...file,
            privacy,
            isLocked: privacy === "private",
            password,
            users,
          }
        : file
    );

    setFiles(updatedFiles);
    setSettingOpen(false);
  };

  const filteredUsers = allUsers.filter(
    (user) =>
      user.toLowerCase().includes(inputValue.toLowerCase()) &&
      !selectedUsers.includes(user)
  );

  const handleSelectUser = (user) => {
    if (!selectedUsers.includes(user)) {
      setSelectedUsers([...selectedUsers, user]);
    }
    setInputValue("");
    setShowDropdown(false);
  };

  const handleRemoveUser = (userToRemove) => {
    setSelectedUsers(selectedUsers.filter((user) => user !== userToRemove));
  };

  return (
    settingOpen && (
      <div className="fixed inset-0 z-50 flex items-center justify-end bg-black bg-opacity-10">
        <div className="bg-white p-6 rounded-lg shadow-lg w-[550px] h-screen">
          <h2 className="mt-5 text-xl font-semibold text-black">Setting</h2>

          {/* Privacy Setting */}
          <div className="mt-5">
            <label className="font-semibold text-gray-700">Visible</label>
            <div className="flex justify-between gap-5 mt-3">
              <label className="relative w-full cursor-pointer">
                <input
                  type="radio"
                  name="privacy"
                  value="public"
                  checked={privacy === "public"}
                  onChange={() => setPrivacy("public")}
                  className="hidden"
                />
                <div
                  className={`w-full px-3 py-2 pl-10 text-sm bg-white border rounded-md ${
                    privacy === "public" ? "border-black " : ""
                  }`}
                >
                  <FaRegUser
                    fontSize={20}
                    className="absolute text-gray-500 top-3 left-3"
                  />
                  Public
                </div>
              </label>

              <label className="relative w-full cursor-pointer">
                <input
                  type="radio"
                  name="privacy"
                  value="private"
                  checked={privacy === "private"}
                  onChange={() => setPrivacy("private")}
                  className="hidden"
                />
                <div
                  className={`w-full px-3 py-2 pl-10 text-sm bg-white border rounded-md ${
                    privacy === "private" ? "border-black" : ""
                  }`}
                >
                  <FaEyeSlash
                    fontSize={20}
                    className="absolute text-gray-500 top-3 left-3"
                  />
                  Private
                </div>
              </label>
            </div>

           <div className="mt-5">
       {privacy === "private" && (
        <div className="mb-4">
          <label className="block mb-1 text-gray-700">Password</label>
          <div className="flex gap-4">
            <label>
              <input
                type="radio"
                name="passwordSet"
                value="yes"
                checked={passwordSet === "yes"}
                onChange={() => setPasswordSet("yes")}
              />
              <span className="ml-2">Yes</span>
            </label>
            <label>
              <input
                type="radio"
                name="passwordSet"
                value="no"
                checked={passwordSet === "no"}
                onChange={() => setPasswordSet("no")}
              />
              <span className="ml-2">No</span>
            </label>
          </div>
        </div>
      )}

     
      {privacy === "private" && passwordSet === "yes" && (
        <div className="mt-5">
          <label className="block mb-1 font-semibold text-gray-700">
            Set Password
          </label>
          <input
            type="password"
            placeholder="Enter password"
            className="w-full px-3 py-2 pl-3 text-sm border rounded-md"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
          />
        </div>
      )}
    </div>
          </div>
          <div></div>

          {/* Add Users */}
          <div className="w-full mt-5">
            <label className="block mb-1 text-gray-700">
              Search to add user
            </label>
            <div className="relative">
              <input
                type="text"
                placeholder="Search to add user"
                className="w-full px-3 py-2 pl-10 text-sm border rounded-md"
                value={inputValue}
                onChange={(e) => {
                  setInputValue(e.target.value);
                  setShowDropdown(true);
                }}
                onFocus={() => setShowDropdown(true)}
              />
              <IoSearch
                fontSize={20}
                className="absolute text-gray-500 top-3 left-3"
              />

              {showDropdown && filteredUsers.length > 0 && (
                <div className="absolute z-10 w-full mt-1 overflow-y-auto bg-white border rounded-md shadow-md max-h-48">
                  {filteredUsers.map((user) => (
                    <div
                      key={user}
                      className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100"
                      onClick={() => handleSelectUser(user)}
                    >
                      {user}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Show selected users as tags */}
            {selectedUsers.length > 0 && (
              <div className="flex flex-wrap gap-2 mt-3">
                {selectedUsers.map((user) => (
                  <div
                    key={user}
                    className="flex items-center px-3 py-1 text-sm bg-gray-200 rounded-full"
                  >
                    {user}
                    <button
                      onClick={() => handleRemoveUser(user)}
                      className="ml-2"
                    >
                      <MdClose className="text-black" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-5 mt-10">
            <button
              className="px-3 py-2 border rounded-md"
              onClick={() => setSettingOpen(false)}
            >
              Cancel
            </button>
            <button
              className="px-3 py-2 text-white bg-black border rounded-md"
              onClick={handleSaveChanges}
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default SettingView;

/* multi selected option show i click search and show the dropdown give full code */
